// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cd225f5b","239":"9c5d5a90","455":"96b7b7cb"}[chunkId] + ".chunk.js";
};